import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiURl from "../controllers/Api";

/**
 * If you're using IonIcon, make sure you've installed:
 *   npm i @ionic/react ionicons
 * and that your app setup supports it.
 */
import { airplaneOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  // const [loginMethod, setLoginMethod] = useState("password"); // 'password' or 'otp' - COMMENTED OUT OTP

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [username, setUsername] = useState("");

  // OTP states - COMMENTED OUT
  // const [otp, setOtp] = useState("");
  // const [otpSent, setOtpSent] = useState(false);
  // const [otpVerified, setOtpVerified] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // OTP timer - COMMENTED OUT
  // const [timer, setTimer] = useState(300); // 5 minutes
  // const [showResend, setShowResend] = useState(false);

  // Animated submit button
  const [btnState, setBtnState] = useState("idle"); // idle | working | done
  const [planeAnim, setPlaneAnim] = useState(false);

  const planeRef = useRef(null);
  const btnRef = useRef(null);

  const navigate = useNavigate();

  // ✅ helper: notify Navbar (and any listener) that auth changed
  const emitAuthChanged = () => {
    window.dispatchEvent(new Event("authChanged"));
  };

  // OTP timer - COMMENTED OUT
  // useEffect(() => {
  //   let interval;
  //   if (otpSent && !otpVerified && timer > 0) {
  //     interval = setInterval(() => {
  //       setTimer((prev) => {
  //         if (prev <= 1) {
  //           setShowResend(true);
  //           clearInterval(interval);
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  //   return () => clearInterval(interval);
  // }, [otpSent, otpVerified, timer]);

  // Set default CSS variables
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--send", "#b29063");
    root.style.setProperty("--default", "#fff");
  }, []);

  // IMPORTANT FIX: make plane travel across full button width (responsive)
  useEffect(() => {
    const updateVars = () => {
      if (!btnRef.current) return;

      const btn = btnRef.current;
      const x = btn.offsetWidth - 40;
      const y = -(btn.offsetHeight * 1.1);

      document.documentElement.style.setProperty("--x", `${x}px`);
      document.documentElement.style.setProperty("--y", `${y}px`);
    };

    updateVars();
    window.addEventListener("resize", updateVars);
    return () => window.removeEventListener("resize", updateVars);
  }, []);

  const resetCommonState = () => {
    setErrorMessage("");
    // OTP reset - COMMENTED OUT
    // setOtpSent(false);
    // setOtpVerified(false);
    // setOtp("");
    // setTimer(300);
    // setShowResend(false);
  };

  const resetAnimatedButton = () => {
    setBtnState("idle");
    setPlaneAnim(false);

    if (planeRef.current) {
      planeRef.current.classList.remove("sendIcon");
      // eslint-disable-next-line no-unused-expressions
      planeRef.current.offsetHeight;
    }
  };

  const toggleForm = () => {
    setIsLogin((v) => !v);
    resetCommonState();
    // setLoginMethod("password"); - COMMENTED OUT
    resetAnimatedButton();

    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setPassword("");
    setConfirmPassword("");
    setUsername("");
  };

  // OTP method setter - COMMENTED OUT
  // const handleSetLoginMethod = (method) => {
  //   setLoginMethod(method);
  //   resetCommonState();
  //   resetAnimatedButton();
  // };

  // OTP send handler - COMMENTED OUT
  // const handleSendOtp = async (e) => {
  //   e.preventDefault();

  //   if (!phone) {
  //     setErrorMessage("Please enter your phone number");
  //     return;
  //   }
  //   if (!/^\d{10}$/.test(phone)) {
  //     setErrorMessage("Please enter a valid 10-digit phone number");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await fetch(`${ApiURl}/send_otp.php`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ phone }),
  //     });

  //     const data = await response.json();
  //     if (data.success) {
  //       setOtpSent(true);
  //       setErrorMessage("");
  //       setTimer(300);
  //       setShowResend(false);
  //     } else {
  //       setErrorMessage(data.message || "Failed to send OTP");
  //     }
  //   } catch (error) {
  //     console.error("Error sending OTP:", error);
  //     setErrorMessage("Failed to send OTP. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // OTP verify handler - COMMENTED OUT
  // const handleVerifyOtp = async (e) => {
  //   e.preventDefault();

  //   if (!otp) {
  //     setErrorMessage("Please enter the OTP");
  //     return;
  //   }
  //   if (!/^\d{6}$/.test(otp)) {
  //     setErrorMessage("Please enter a valid 6-digit OTP");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const endpoint = isLogin ? "verify_otp.php" : "verify_otp_sign.php";
  //     const response = await fetch(`${ApiURl}/${endpoint}`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ phone, otp }),
  //     });

  //     const data = await response.json();
  //     if (data.success) {
  //       setOtpVerified(true);
  //       setErrorMessage("");
  //     } else {
  //       setErrorMessage(data.message || "Invalid OTP");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP:", error);
  //     setErrorMessage("Failed to verify OTP. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // OTP section visibility - COMMENTED OUT (always use password)
  // const showOtpSection = (isLogin && loginMethod === "otp") || !isLogin;
  // const showPasswordSection = (isLogin && loginMethod === "password") || (!isLogin && otpVerified);
  
  // Simplified - always show password section
  const showPasswordSection = true;

  // const isSubmitDisabled = loading || (!isLogin && !otpVerified) || planeAnim;
  const isSubmitDisabled = loading || planeAnim;

  const submitLabel = useMemo(() => {
    if (btnState === "working") return isLogin ? "LOGGING IN" : "SIGNING UP";
    if (btnState === "done") return "DONE";
    return isLogin ? "LOGIN" : "SIGNUP";
  }, [btnState, isLogin]);

  const playPlaneAnimationAndThen = (onDone) => {
    if (planeAnim) return;

    setPlaneAnim(true);
    setBtnState("idle");

    requestAnimationFrame(() => {
      if (!planeRef.current) return;
      planeRef.current.classList.remove("sendIcon");
      // eslint-disable-next-line no-unused-expressions
      planeRef.current.offsetHeight;
      planeRef.current.classList.add("sendIcon");
    });

    setTimeout(() => setBtnState("working"), 900);
    setTimeout(() => setBtnState("done"), 2400);

    setTimeout(async () => {
      setPlaneAnim(false);
      setBtnState("idle");
      await onDone?.();
    }, 4100);
  };

  const doAuthRequest = async () => {
    const payload = isLogin
      ? { phone, password } // Removed OTP option, always use password
      : {
          firstname,
          username,
          lastname,
          email,
          phone,
          password,
          confirm_password,
        };

    if (isLogin && (!phone || !password)) {
      throw new Error("Phone and password are required");
    }
    if (!isLogin && (!phone || !password || password !== confirm_password)) {
      throw new Error("Validation failed - check your inputs");
    }

    const endpoint = isLogin ? "login.php" : "signup.php";

    const response = await fetch(`${ApiURl}/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();
    let responseData;
    try {
      responseData = responseText ? JSON.parse(responseText) : {};
    } catch {
      throw new Error("Invalid server response format");
    }

    if (!response.ok) {
      throw new Error(responseData.message || `HTTP error! status: ${response.status}`);
    }

    if (!responseData.success) {
      throw new Error(responseData.message || "An error occurred during authentication");
    }

    // ✅ success storage
    localStorage.setItem("token", responseData.token || "");
    localStorage.setItem("cart_id", responseData.cart_id || "");
    localStorage.setItem("user_id", responseData.user_id || responseData.user?.user_id || "");
    localStorage.setItem("role", responseData.role || responseData.user?.role || "user");
    localStorage.setItem("phone", responseData.phone || phone);

    if (responseData.user) {
      localStorage.setItem("userData", JSON.stringify(responseData.user));
    }

    // ✅ IMPORTANT: notify Navbar immediately (same-tab)
    emitAuthChanged();

    if (!isLogin) {
      toggleForm();
      setErrorMessage("Signup successful! Please log in.");
      return;
    }

    navigate("/dashboard");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      if (isLogin && (!phone || !password))
        throw new Error("Phone and password are required");
      if (!isLogin && (!phone || !password || password !== confirm_password))
        throw new Error("Validation failed - check your inputs");
    } catch (err) {
      setErrorMessage(err.message);
      return;
    }

    playPlaneAnimationAndThen(async () => {
      setLoading(true);
      try {
        await doAuthRequest();
      } catch (error) {
        const msg = String(error?.message || "");
        setErrorMessage(
          msg.includes("Failed to fetch")
            ? "Network error - please check your connection"
            : msg || "An unexpected error occurred. Please try again."
        );
      } finally {
        setLoading(false);
      }
    });
  };

  // OTP button - COMMENTED OUT
  // const otpButtonLabel =
  //   otpVerified && !isLogin
  //     ? "Verified"
  //     : loading
  //     ? "Processing..."
  //     : showResend
  //     ? "Resend OTP"
  //     : otpSent
  //     ? "Verify OTP"
  //     : "Send OTP";

  // const handleOtpButtonClick = (e) => {
  //   if (showResend) return handleSendOtp(e);
  //   if (otpSent && !otpVerified) return handleVerifyOtp(e);
  //   return handleSendOtp(e);
  // };

  return (
    <>
      <style>{`
        :root{
          --x : 300px;
          --y : -20px;
          --send: #b29063;
          --default: #fff;
        }
        .sendIcon{ animation: plane-up 4s ease-in-out forwards; }
        @keyframes plane-up {
          0% { transform: translate(0px, 0px) rotate(90deg); }
          10% { transform: translate(0px, 0px) rotate(0deg); color: var(--default); }
          20% { color: var(--send); transform: translate(0px, var(--y)) rotate(0deg); }
          40% { color: var(--send); transform: translate(0px, var(--y)) rotate(90deg); }
          50% { color: var(--send); transform: translate(var(--x), var(--y)) rotate(90deg); }
          60% { color: var(--send); transform: translate(var(--x), var(--y)) rotate(180deg); }
          80% { color: var(--default); transform: translate(var(--x), 0px) rotate(180deg); }
          100% { color: var(--default); transform: translate(var(--x), 0px) rotate(270deg); }
        }
      `}</style>

      <div className="min-h-screen flex items-center justify-center bg-[var(--user-bg,#E8D9D5)] px-4 py-10 font-['Poppins',sans-serif]">
        <div className="w-full max-w-lg rounded-2xl border border-gray-200 bg-white shadow-xl">
          <div className="p-8">
            <h2 className="text-2xl font-bold text-center text-black mb-2">
              {isLogin ? "Login" : "Signup"}
            </h2>

            <p className="text-center text-sm text-gray-700 mb-8">
              {isLogin ? "Welcome back. Please enter your details." : "Create your account to continue."}
            </p>

            {/* OTP/Password toggle - COMMENTED OUT */}
            {/* {isLogin && (
              <div className="flex justify-center mb-6">
                <div className="inline-flex rounded-lg border border-gray-200 bg-white overflow-hidden">
                  <button
                    type="button"
                    onClick={() => handleSetLoginMethod("password")}
                    className={`px-4 py-2 text-sm font-semibold transition-colors ${
                      loginMethod === "password"
                        ? "bg-gradient-to-r from-[#b29063] to-[#d4b78f] text-white"
                        : "bg-white text-black hover:bg-gray-100"
                    }`}
                  >
                    Password
                  </button>
                  <button
                    type="button"
                    onClick={() => handleSetLoginMethod("otp")}
                    className={`px-4 py-2 text-sm font-semibold transition-colors ${
                      loginMethod === "otp"
                        ? "bg-gradient-to-r from-[#b29063] to-[#d4b78f] text-white"
                        : "bg-white text-black hover:bg-gray-100"
                    }`}
                  >
                    OTP
                  </button>
                </div>
              </div>
            )} */}

            {errorMessage && (
              <div className="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-center text-sm text-red-700">
                {errorMessage}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {!isLogin && (
                <>
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-black mb-2" htmlFor="username">
                      Username
                    </label>
                    <input
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      type="text"
                      id="username"
                      className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063]"
                      placeholder="Enter your username"
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-semibold text-black mb-2" htmlFor="firstname">
                        First Name
                      </label>
                      <input
                        value={firstname}
                        onChange={(e) => setFirstName(e.target.value)}
                        type="text"
                        id="firstname"
                        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063]"
                        placeholder="First name"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-black mb-2" htmlFor="lastname">
                        Last Name
                      </label>
                      <input
                        value={lastname}
                        onChange={(e) => setLastName(e.target.value)}
                        type="text"
                        id="lastname"
                        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063]"
                        placeholder="Last name"
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-black mb-2" htmlFor="email">
                      Email
                    </label>
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      id="email"
                      className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063]"
                      placeholder="your@email.com"
                    />
                  </div>
                </>
              )}

              <div className="mb-4">
                <label className="block text-sm font-semibold text-black mb-2" htmlFor="mobileNo">
                  Mobile Number
                </label>
                <input
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                  type="tel"
                  id="mobileNo"
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063] bg-[#f9f7f3]"
                  placeholder="10-digit number"
                  required
                />
              </div>

              {/* OTP Section - COMMENTED OUT */}
              {/* {showOtpSection ? (
                <div className="mb-6">
                  <div className="flex gap-2">
                    <input
                      value={otp}
                      onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                      type="tel"
                      id="otp"
                      className="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063] disabled:bg-gray-50 disabled:text-gray-400 bg-[#f9f7f3]"
                      placeholder="6-digit OTP"
                      required
                      disabled={!otpSent || (otpVerified && !isLogin)}
                    />

                    <button
                      type="button"
                      onClick={handleOtpButtonClick}
                      disabled={loading || (otpVerified && !isLogin)}
                      className={`min-w-[130px] rounded-lg px-4 py-2 text-sm font-semibold text-white transition-all ${
                        loading || (otpVerified && !isLogin)
                          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                          : "bg-gradient-to-r from-[#b29063] to-[#d4b78f] hover:from-[#a08053] hover:to-[#c4a77f]"
                      }`}
                    >
                      {otpButtonLabel}
                    </button>
                  </div>

                  {otpSent && !otpVerified && (
                    <div className="text-center text-xs text-gray-700 mt-2">
                      {timer > 0
                        ? `Resend OTP in ${Math.floor(timer / 60)}:${(timer % 60).toString().padStart(2, "0")} minutes`
                        : "You can now resend OTP"}
                    </div>
                  )}
                </div>
              ) : null} */}

              {showPasswordSection ? (
                <>
                  <div className="mb-6">
                    <label className="block text-sm font-semibold text-black mb-2" htmlFor="password">
                      Password
                    </label>
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type="password"
                      id="password"
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063] bg-[#f9f7f3]"
                      placeholder={isLogin ? "Your password" : "At least 6 characters"}
                      required
                      minLength={isLogin ? undefined : 6}
                    />
                  </div>

                  {!isLogin && (
                    <div className="mb-4">
                      <label className="block text-sm font-semibold text-black mb-2" htmlFor="confirmPassword">
                        Confirm Password
                      </label>
                      <input
                        value={confirm_password}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type="password"
                        id="confirmPassword"
                        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#b29063]"
                        placeholder="Confirm your password"
                        required
                      />
                    </div>
                  )}
                </>
              ) : null}

              <button
                ref={btnRef}
                type="submit"
                disabled={isSubmitDisabled}
                className={`relative mt-2 w-full rounded-2xl px-4 py-3 text-center text-base font-bold text-white shadow-md transition-all
                  ${
                    isSubmitDisabled
                      ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                      : "bg-gradient-to-r from-[#b29063] to-[#d4b78f] hover:from-[#a08053] hover:to-[#c4a77f]"
                  }
                `}
              >
                <span
                  ref={planeRef}
                  className={`absolute left-3 top-1/2 z-10 -translate-y-1/2 text-white pointer-events-none ${
                    planeAnim ? "sendIcon" : ""
                  }`}
                  style={{ display: "inline-flex" }}
                >
                  <span style={{ display: "inline-flex", transform: "rotate(90deg)" }}>
                    <IonIcon icon={airplaneOutline} className="text-2xl" />
                  </span>
                </span>

                <span className="inline-block">{submitLabel}</span>
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-sm text-gray-700">
                {isLogin ? "Don't have an account?" : "Already have an account?"}
                <button
                  type="button"
                  className="ml-1 text-sm font-bold text-[#b29063] hover:text-[#a08053] underline underline-offset-4 disabled:text-gray-400"
                  onClick={toggleForm}
                  disabled={loading}
                >
                  {isLogin ? "Sign up" : "Log in"}
                </button>
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 px-8 py-4">
            <p className="text-center text-xs text-gray-600">
              By continuing, you agree to our Terms and Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
